module.exports = __webpack_public_path__ + "img/sv81on.9269a19f.svg";